import {
  Container,
  BlurContainer,
  ContentsContainer,
  TitleWrapper,
  DescWrapper,
  ButtonWrapper,
  Li,
} from './BlurScreen.styles';
import greenRight from '@/assets/green_right.svg';

export default function BlurScreen({ title, descriptions, onClick, open }) {
  return (
    <Container open={open}>
      <BlurContainer />
      <ContentsContainer>
        <TitleWrapper>
          <div className="text-text-300">{title}</div>
        </TitleWrapper>
        <DescWrapper>
          {descriptions?.map((desc, i) => (
            <Li key={i}>
              <span className="text-text-300 text-sm">{desc}</span>
            </Li>
          ))}
        </DescWrapper>

        <ButtonWrapper onClick={onClick}>
          <div className="text-primary-500 text-sm">Continue</div>
          <img src={greenRight} />
        </ButtonWrapper>
      </ContentsContainer>
    </Container>
  );
}
